import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { createCodeCacheUtils } from '../utils/codeCacheUtils';

/**
 * On project switch, removes code list caches from other projects so that
 * returning to them triggers a fresh fetch (repopulating code detail entries).
 */
export function useProjectCacheReset(projectId) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!projectId) return;
    const codeCacheUtils = createCodeCacheUtils(queryClient);
    codeCacheUtils.removeOtherProjectCodeLists(projectId);
  }, [projectId, queryClient]);
}
